import { useIntl } from 'react-intl';

import { PaidHeroTabPanelTemplate } from './hero-tab-panel-template';

const HRTabContent = () => {
	const intl = useIntl();

	const hrHeroProps = {
		header: intl.formatMessage({
			id: 'JiraSoftwarePagePaidLpJswFeatures.hero.hr.header',
			defaultMessage: 'Build teamwork and productivity across your organization with Jira',
		}),
		image: {
			src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/o3vf21711xl7j3k661enul0050252c02.webp',
			alt: intl.formatMessage({
				id: 'JiraSoftwarePagePaidLpJswFeatures.hr.heroImageAlt',
				defaultMessage: 'Screen capture of a Jira backlog',
			}),
		},
	};

	return <PaidHeroTabPanelTemplate {...hrHeroProps} />;
};

export default HRTabContent;
